import {
  SbPasskeyButton,
  SbProviderButton,
} from "@/components/renderers/auth/button";
import {
  SbConfirmField,
  SbEmailField,
  SbIdentifierField,
  SbNameField,
  SbPasswordField,
  SbPhoneField,
  SbUsernameField,
} from "@/components/renderers/auth/field";
import { SbLink } from "@/components/renderers/navigation/link";
import { SbOtp } from "@/components/renderers/auth/otp";

export const FIELDS = [
  SbEmailField,
  SbPhoneField,
  SbUsernameField,
  SbIdentifierField,
  SbNameField,
  SbPasswordField,
  SbConfirmField,
  SbOtp,
];

export const INTERACTIVES = [SbPasskeyButton, SbProviderButton, SbLink];
